if (!customElements.get('collection-tabs')) {
  customElements.define(
    'collection-tabs',
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();

        this.tab = this.querySelector('tabs-component');
        this.tabPanels = this.querySelectorAll('[role="tabpanel"]');
        this.tabNavs = this.querySelectorAll('[role="tab"]');
        this.contentWrapper = this.querySelector('.collection-tabs__content');
        this.imagesWrapper = this.querySelector('.collection-tabs__images');
        this.tooltipEl = this.querySelector('.tooltip-element');

        this.init();
      }

      connectedCallback() {
        this.tab.addEventListener('tabChange', (event) => {
          this.handleTabChange(event);
        });
      }

      init() {
        this.handleTooltip(0);
        requestAnimationFrame(() => this.calculatePadding());
        window.addEventListener('resize', FoxTheme.utils.debounce(this.calculatePadding.bind(this), 100));
      }

      handleTabChange(event) {
        const {selectedIndex} = event.detail;
        this.handleTooltip(selectedIndex);

        this.imagesWrapper.querySelectorAll('.collection-tabs__image').forEach((image) => image.classList.remove('is-active'));
        this.imagesWrapper.querySelector(`.collection-tabs__image[data-index="${selectedIndex}"]`).classList.add('is-active');
      }

      handleTooltip(tabIndex) {
        if (!window.matchMedia("(hover: hover)").matches) return;
        const currentTab = this.tabPanels[tabIndex];
        const productListWrapper = currentTab.querySelector('.collection-tab__products');
        const hoverEls = productListWrapper.querySelectorAll('a');

        hoverEls.forEach((el) => {
          el.addEventListener('mousemove', (e) => {
            // Lazy-read once on first hover to avoid layout read during page init.
            if (this._tooltipHeight === undefined) {
              this._tooltipHeight = this.tooltipEl.offsetHeight || 28;
            }
            const title = e.target.dataset.title;
            this.tooltipEl.innerHTML = title;
            this.tooltipEl.style.opacity = '1';
            this.tooltipEl.style.top = `${e.clientY - this._tooltipHeight - 5}px`;
            this.tooltipEl.style.left = `${e.clientX}px`;
          });

          el.addEventListener('mouseleave', () => {
            this.tooltipEl.style.opacity = '0';
          });
        });
      }

      calculatePadding() {
        // Lazy-read align-items once to avoid getComputedStyle during construction.
        if (this._alignItems === undefined) {
          this._alignItems = window.getComputedStyle(this).getPropertyValue('align-items');
        }
        const contentHeight = this.contentWrapper.offsetHeight;
        const imageHeight = this.imagesWrapper.offsetHeight;
        const diff = Math.abs(imageHeight - contentHeight);

        if (this._alignItems === 'center' || diff < 0) return;
        this.contentWrapper.style.marginTop = `${diff / 2}px`;
      }
    }
  );
}
